<template>
  <div class="added-product-overview-wrap" v-if="item.product_name">
    <div class="added-product-overview is-flex justify-content-between">
      <div class="added-product-left">
        <p class="has-text-weight-semibold max-2-line has-text-dark">{{ item.product_name}} </p>
        <p class="is-size-11 has-text-weight-semibold is-uppercase mt10 letter-space-1 has-text-grey" v-if="item.brand_name && (item.brand_name != 'No Brand')">{{ item.brand_name }}</p>
        <p v-if="(item.product_family == 'cannabis') && item.cannabis_attributes && item.cannabis_attributes.plant_type" class="is-size-14 text-primary has-text-weight-semibold letter-space-1 is-capitalized font-color mt10">{{ item.cannabis_attributes.plant_type }}</p>
      </div>
        <div class="added-product-right">
        <p class="is-size-14 has-text-right has-text-dark" v-if="item.selected_variant">Variant: {{ item.selected_variant.size }}</p>
        <div class="level-item mt-15">
          <div class="quantity-block is-width-xs mb0">
            <button value="-" @click="decreaseQty" class="button minus bg-secondary hover-opacity-7 text-white"><i class="fas fa-minus"></i></button>
            <div class="field mb0">
              <div class="control disable-click-event">
                <input class="input is-shadowless pointer-none" type="number" v-model="qty" value="1">
                <span v-text="qty" class="display-qty min-width-100 has-text-weight-bold has-text-dark"></span>
              </div>
            </div>
            <button  @click="increaseQty" value="+" class="button plus bg-secondary hover-opacity-7 text-white">
              <i class="fas fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import CartApis from '@/Components/Controllers/CartApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import Env from '@/env';
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';

export default {
  
  name: 'CartRecommendProductsAddedItems',
  props: {
    item: {
      required: true,
      type: Object
    },
  },
  data() {
    return {
      qty: 1,
    };
  },
  computed: {
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_cartEveryItemCount: "cart/cartEveryItemCount",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_userId: "getLoggedInUserId",
    }),
  },

  async mounted() {
    this.qty = this.item.unit;
  },

  methods: {
    /**
     * Increase quantity
     */
    increaseQty: async function(event) {
      if(event.detail && event.detail != 1){
        // prevent fast multiple clicks
        return false;
      } 
      // before increase check if can increase within limit ot not
      if( parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
      } else {

        let productItem = _.find(this.vg_cartItems, { 
          location_product_id: parseInt(this.item.location_product_id), 
          location_product_variant_id: parseInt(this.item.selected_variant.id) 
        });

        if(_.isEmpty(productItem)){
          return;
        }

        let totalQtyAdterAdd = this.qty + 1;
        let maxQtyCanAdd = parseInt(productItem.selected_variant.no_of_units - productItem.selected_variant.inventory_threshold);
        if(totalQtyAdterAdd > maxQtyCanAdd){
          // reject cannot add qut more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        }  

        let newWeight = parseFloat(productItem.weight) + parseFloat(this.vg_weightOnCart)
        if(newWeight > parseFloat(this.vg_cannabisLimit) ){
          bus.$emit('show-modal-cart-limit-exceed', {
            overWeight: newWeight.toFixed(2),
            modal: true,
          });
        } else {
          productItem.unit++;
          let res = await this.updateCartItem(productItem);
          this.qty = productItem.unit;
          if(res && this.$store.getters.getLoggedInUserToken) {
            // on add +1 
            var obj = _.clone(productItem);
            obj.unit = 1;
            VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, productItem.product_id), this.vg_selectedStore.id);
          }
          // Add cart item, G tracking add to cart
          this.GtagAddRemoveItem('add_to_cart');
        }
      }
    },

    /**
     * Gtag update add remove item
     */
     GtagAddRemoveItem(key){
       if(!key){
         return;
       }
       this.$gtag.event(key, { 
        items: [
          {
            id: this.item.location_product_id,
            name: this.item.product_name, 
            brand: this.item.brand_name ? this.item.brand_name : null,
            category: this.item.category_name ? this.item.category_name : null,
            variant: this.item.selected_variant.size ? this.item.selected_variant.size : null,
            quantity: parseInt(this.item.unit),
            price: this.item.price,
          }
        ]
      });
     },

    /**
     * Decrease quantity
     */
    decreaseQty: async function (event) {
    // decreaseQty() {
      if(event.detail && event.detail != 1){
        // prevent fast multiple clicks
        return false;
      } 

      if (this.qty > 1){
        let productItem = _.find(this.vg_cartItems, { 
          location_product_id: parseInt(this.item.location_product_id), 
          location_product_variant_id: parseInt(this.item.selected_variant.id) 
        });

        if(_.isEmpty(productItem)){
          return;
        }
        productItem.unit--;
        let res = await this.updateCartItem(productItem);
        if(res && this.$store.getters.getLoggedInUserToken) {
          VboutApis.removeCartItem({
            cartid: this.$store.getters['cart/id'],
            productid: productItem.product_id,
            variation: { 
              variation_id: productItem.selected_variant.id, 
            },
          }, this.vg_selectedStore.id);
        }
        // Remove cart item, G tracking add to cart
        this.GtagAddRemoveItem('remove_from_cart');
      } else {
        bus.$emit('added-to-cart-recommend-product-removed', this.item);
      }
    },

     /**
     * Update cart item 
     */
    async updateCartItem(item) {
 
      this.va_spinner(true);
       //Clone the object and filter
      var obj = _.clone(item);
      obj.cart_item_id = item.id;
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.status == 200 ? 'success' : 'error',
      });
      if(res.status == 200){
        this.qty = obj.unit; 
        return true;
      } else {
        return false;
      }
    },

   
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
    })

  },
};
</script>
<style scoped>
.added-product-overview-wrap{
  padding: 20px
}
</style>
